import { Button, Col, Container, Form, Row } from "react-bootstrap";

const GeneralTab = () => {
    return (
        <div className="general_tab_screen">
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Form>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Temperature (F)</Form.Label>
                                        <Form.Control type="text" placeholder="temperature" required />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Weight (Kg)</Form.Label>
                                        <Form.Control type="text" placeholder="20" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Heartbeat (BPM)<span>*</span></Form.Label>
                                        <Form.Control type="text" placeholder="+91-7987987987" />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Blood Pressure (mm/hg)<span>*</span></Form.Label>
                                        <Row>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Control type="text" placeholder="Ex. 102" />
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Control type="text" placeholder="Ex. 72" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Form.Group className="form-group">
                                    <Form.Label>Oxygen Saturation (Spo2/Prbpm)<span>*</span></Form.Label>
                                    <Row>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                            <Form.Control type="text" placeholder="Ex. 97 SPo2" />
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                            <Form.Control type="text" placeholder="Ex. 60PRbpm" />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Form.Group className="form-group">
                                    <Form.Label>Blood Sugar (mg/dl)<span>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="Ex. 104mg/dl" />
                                </Form.Group>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Form.Group className="form-group">
                                    <Form.Label>Aadhar Card No<span>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="7897-7888-7878" required />
                                </Form.Group>
                            </Col>
                            <div className="btn_area">
                                <Button className="cancelBtn" type="button" >Cancel</Button>
                                <Button className="submitBtn" type="submit">Submit</Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </div >
    )
};

export default GeneralTab;